var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.375 22a2.18 2.18 0 0 1-1.59-.653 2.13 2.13 0 0 1-.66-1.57V5.334q-.478 0-.802-.32A1.07 1.07 0 0 1 3 4.224q0-.474.323-.792.324-.32.802-.32h4.5q0-.473.323-.792Q9.272 2 9.75 2h4.5q.478 0 .802.32.323.318.323.791h4.5q.478 0 .802.32.323.319.323.791t-.323.792-.802.32v14.444q0 .916-.66 1.57a2.18 2.18 0 0 1-1.59.652zm11.25-16.667H6.375v14.445h11.25zM9.75 17.556q.478 0 .802-.32.323-.32.323-.792V8.667q0-.473-.323-.792a1.1 1.1 0 0 0-.802-.32q-.478 0-.802.32a1.07 1.07 0 0 0-.323.792v7.777q0 .473.323.792.324.32.802.32m4.5 0q.478 0 .802-.32.323-.32.323-.792V8.667q0-.473-.323-.792a1.1 1.1 0 0 0-.802-.32q-.478 0-.802.32a1.07 1.07 0 0 0-.323.792v7.777q0 .473.323.792.324.32.802.32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteOutline);
export default __webpack_public_path__ + "static/media/delete_outline.5088532e72839817bd5fcbf4fb972bb1.svg";
export { ForwardRef as ReactComponent };